export class ComponentCausedFailurerDTO {
    id!: number;
    name?: string;
    description?: string;
    isActive?: boolean;
  }